import Link from 'next/link';
import { display } from '../lib/fonts';

export default function Footer() {
  return (
    <footer className="bg-slate-950 dark:bg-gray-950 text-gray-400 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-10 mb-12">

          {/* Brand */}
          <div className="col-span-1 sm:col-span-2 lg:col-span-2">
            <Link href="/" className="inline-block mb-4">
              <span className={`${display.className} text-2xl font-extrabold bg-gradient-to-r from-customBlue to-cyan-400 bg-clip-text text-transparent`}>
                Doogler
              </span>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed mb-5">
              India&apos;s direct employee referral job portal. Skip the queue, land interviews faster, and secure your dream role.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://www.linkedin.com/company/doogler/" target="_blank" rel="noopener noreferrer"
                aria-label="LinkedIn" className="w-9 h-9 rounded-xl bg-white/5 hover:bg-customBlue/20 border border-white/5 flex items-center justify-center text-gray-400 hover:text-customBlue transition-all">
                <i className="fab fa-linkedin text-sm"></i>
              </a>
              <a href="https://www.instagram.com/doogler.in/" target="_blank" rel="noopener noreferrer"
                aria-label="Instagram" className="w-9 h-9 rounded-xl bg-white/5 hover:bg-pink-500/20 border border-white/5 flex items-center justify-center text-gray-400 hover:text-pink-400 transition-all">
                <i className="fab fa-instagram text-sm"></i>
              </a>
              <a href="#" aria-label="Twitter"
                className="w-9 h-9 rounded-xl bg-white/5 hover:bg-sky-500/20 border border-white/5 flex items-center justify-center text-gray-400 hover:text-sky-400 transition-all">
                <i className="fab fa-twitter text-sm"></i>
              </a>
            </div>
          </div>

          {/* Platform */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 tracking-wide">Platform</h3>
            <ul className="space-y-3">
              {[
                { href: '/job_search', label: 'Job Search' },
                { href: '/browse-jobs', label: 'Browse Referral Jobs' },
                { href: '/blog/jobs-in-bangalore-noida-delhi-ncr-guide', label: 'Jobs by City' },
                { href: '/blog/become-a-referrer-benefits-for-employees', label: 'Become a Referrer' },
                { href: '/AI_mock_interview', label: 'AI Mock Interview' },
                { href: '/sign-up', label: 'Create Account' },
              ].map(link => (
                <li key={link.href}>
                  <Link href={link.href} className="inline-block py-1 text-sm hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 tracking-wide">Resources</h3>
            <ul className="space-y-3">
              {[
                { href: '/blog', label: 'Career Blog' },
                { href: '/blog/how-to-get-a-job-referral-in-india', label: 'How to Get a Referral' },
                { href: '/blog/fresher-jobs-in-india-how-to-get-your-first-job', label: 'Fresher Jobs Guide' },
                { href: '/blog/resume-tips-for-it-jobs-in-india', label: 'Resume Tips' },
                { href: '/blog/ai-mock-interview-how-to-prepare-and-practice', label: 'Interview Prep' },
                { href: '/faq', label: 'FAQs' },
              ].map(link => (
                <li key={link.href}>
                  <Link href={link.href} className="inline-block py-1 text-sm hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 tracking-wide">Company</h3>
            <ul className="space-y-3">
              {[
                { href: '/', label: 'About Doogler' },
                { href: '/privacy', label: 'Privacy Policy' },
                { href: '/terms', label: 'Terms & Conditions' },
                { href: '/sitemap.xml', label: 'Sitemap' },
                { href: '/llms.txt', label: 'llms.txt' },
              ].map(link => (
                <li key={link.href}>
                  <Link href={link.href} className="inline-block py-1 text-sm hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 tracking-wide">Support</h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:help@doogler.in?subject=Support" className="inline-block py-1 text-sm hover:text-white transition-colors duration-200">
                  help@doogler.in
                </a>
              </li>
              <li>
                <a href="mailto:help@doogler.in?subject=BUG" className="inline-block py-1 text-sm hover:text-white transition-colors duration-200">
                  Report a Bug
                </a>
              </li>
              <li>
                <Link href="/faq" className="inline-block py-1 text-sm hover:text-white transition-colors duration-200">
                  Help Center
                </Link>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-600">
          <div>
            <p>© {new Date().getFullYear()} Doogler (India). All rights reserved.</p>
            <p className="mt-0.5">All trademarks are the property of their respective owners.</p>
          </div>
          <div className="flex items-center gap-1.5">
            <span>Made with</span>
            <span className="text-red-500" aria-label="love" role="img">❤</span>
            <span>by</span>
            <a href="https://www.webnesters.in/" target="_blank" rel="noopener noreferrer"
              className="text-gray-400 hover:text-white font-medium transition-colors">
              Webnesters
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}